import CryptoJS from 'crypto-js';

// Shared key (ideally fetched from a secure backend endpoint)
const ENCRYPTION_KEY = 'b14ca5898a4e4133bbce2ea2315a1916';

export function encryptString(text: string): string {
  const key = CryptoJS.enc.Utf8.parse(ENCRYPTION_KEY);
  const iv = CryptoJS.lib.WordArray.create(new Uint8Array(16));
  const encrypted = CryptoJS.AES.encrypt(text, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
}